
import { defineComponent, ref } from "vue";
import dayjs from "dayjs";

export default defineComponent({
  name: "kt-widget-11",
  components: {},
  props: {
    widgetClasses: String,
  },
  setup() {
    const list = [
      {
        product: {
          image: "/media/stock/600x400/img-38.jpg",
          name: "Nutra Ceuticals For You",
          specs: "www.nutraceutsyou.com",
          phone: "800-888-5554",
        },
        price: "$27.90",
        trial: "2023/01/23",
        producttype: {
          name: "Daily Face Cream",
          position: "Subscription",
        },
        status: {
          label: "Approved",
          color: "primary",
        },
      },
    ];
    const now = new Date();

    const tableData = ref([
      {
        date: "Mechant Ceutical",
        name: "1.800.588.9855",
        state: "mnutraceut.com",
        city: "MN*nutra-80022",
        address: "No. 189, Grove St, Los Angeles",
        zip: "CA 90036",
      },
      {
        date: "2016-05-02",
        name: "Tom",
        state: "California",
        city: "Los Angeles",
        address: "No. 189, Grove St, Los Angeles",
        zip: "CA 90036",
      },
      {
        date: "2016-05-03",
        name: "Tom",
        state: "California",
        city: "Los Angeles",
        address: "No. 189, Grove St, Los Angeles",
        zip: "CA 90036",
      },
    ]);

    const deleteRow = (index: number) => {
      tableData.value.splice(index, 1);
    };

    const onAddItem = () => {
      now.setDate(now.getDate() + 1);
      tableData.value.push({
        date: dayjs(now).format("YYYY-MM-DD"),
        name: "Tom",
        state: "California",
        city: "Los Angeles",
        address: "No. 189, Grove St, Los Angeles",
        zip: "CA 90036",
      });
    };
    return {
      now,
      tableData,
      list,
      deleteRow,
      onAddItem,
    };
  },
});
